import React from 'react'

import { Button, Icon, Link, Motion, Text, Wrapper } from 'Components/UI'

import pageNotFoundGlyph from 'Assets/_Legacy/Svg/page-not-found.svg'

import { ROOT } from 'Constants/Paths'

import { Container, Content, ImageHolder } from './styles'

function Hero() {
  return (
    <Container>
      <Wrapper>
        <Content>
          <Motion>
            <ImageHolder>
              <Icon glyph={pageNotFoundGlyph} size={['100%', 500]} />
            </ImageHolder>
          </Motion>
          <Motion>
            <Text as="h1" center fontSize={[32, 48]} medium mt={[3, 4]}>
              You stepped somewhere wrong :(
            </Text>
          </Motion>
          <Link href={ROOT}>
            <Button big mt={[3, 40]} outline secondary width={[1, 'auto']}>
              Back to homepage
            </Button>
          </Link>
        </Content>
      </Wrapper>
    </Container>
  )
}

Hero.defaultProps = {}

Hero.propTypes = {}

export default Hero
